export interface ProductOption {
  id: string;
  label: string;
}

export const PRODUCT_OPTIONS: ProductOption[] = [
  { id: 'fpv-one-pilot', label: 'FPV.One Pilot' },
  { id: 'fpv-one-race', label: 'FPV.One Race' },
  { id: 'fpv-ctrl', label: 'FPV.Ctrl' },
  { id: 'dream-x', label: 'Dream X' },
  { id: 'drone-soccer', label: 'Drone Soccer' },
  { id: 'fpv-ace', label: 'FPV.Ace' },
  { id: 'power-meter-v2', label: 'Power Meter v2' },
  { id: 'lap-rf', label: 'LapRF' },
  { id: 'rapid-fire', label: 'rapidFIRE' },
  { id: 'skydive', label: 'SkyDive' },
  { id: 'f405-3030-fc', label: 'F405 3030 FC' },
  { id: '4in1-3030-esc', label: '4IN1 3030 ESC' },
  { id: 'fpv-pro', label: 'FPV.Pro' },
  { id: 'mrm2-10', label: 'MRM2-10' },
  { id: 'mrm1-5', label: 'MRM1-5' },
  { id: 'h7-wingcore', label: 'H7 Wingcore' },
  { id: 'other', label: 'Other' },
];

export const PRODUCT_OPTIONS_DEVELOPER: ProductOption[] = [
  { id: 'developer-program', label: 'Developer Program' },
  { id: 'fpv-one-pilot', label: 'FPV.One Pilot' },
  { id: 'fpv-one-race', label: 'FPV.One Race' },
  { id: 'fpv-ctrl', label: 'FPV.Ctrl' },
  { id: 'dream-x', label: 'Dream X' },
  { id: 'drone-soccer', label: 'Drone Soccer' },
  { id: 'fpv-ace', label: 'FPV.Ace' },
  { id: 'power-meter-v2', label: 'Power Meter v2' },
  { id: 'lap-rf', label: 'LapRF' },
  { id: 'rapid-fire', label: 'rapidFIRE' },
  { id: 'skydive', label: 'SkyDive' },
  { id: 'f405-3030-fc', label: 'F405 3030 FC' },
  { id: '4in1-3030-esc', label: '4IN1 3030 ESC' },
  { id: 'fpv-pro', label: 'FPV.Pro' },
  { id: 'mrm2-10', label: 'MRM2-10' },
  { id: 'mrm1-5', label: 'MRM1-5' },
  { id: 'other', label: 'Other' },
];

export const PRODUCT_OPTIONS_SHORTER: ProductOption[] = [
  {
    id: 'ground_airborne_systems',
    label: 'Ground & Airborne Systems',
  },
  {
    id: 'drones',
    label: 'Drones',
  },
  {
    id: 'fpv_components',
    label: 'FPV Components',
  },
  {
    id: 'simulator',
    label: 'Simulator',
  },
  {
    id: 'other',
    label: 'Other',
  },
];
